import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges, Output
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-enum-combobox',
  templateUrl: './enum-combobox.component.html',
  styleUrls: ['./enum-combobox.component.scss']
})
export class EnumComboboxComponent<T> implements OnInit, OnChanges {
  @Input() enumType!: any;
  @Input() label = 'Selecteer waarde';
  @Input() preFilledValue?: T;

  @Output() valueChange = new EventEmitter<T>();

  control = new FormControl<T | null>(null);
  options: { key: string; value: T }[] = [];

  ngOnInit(): void {
    this.options = this.getEnumOptions<T>(this.enumType);

    if (this.preFilledValue !== undefined) {
      this.control.setValue(this.preFilledValue);
    }

    this.control.valueChanges.subscribe(value => {
      if (value !== null && value !== undefined) {
        this.valueChange.emit(value as T);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['preFilledValue'] && !changes['preFilledValue'].firstChange) {
      const newValue = changes['preFilledValue'].currentValue as T;
      this.control.setValue(newValue, { emitEvent: false });
    }
  }

  private getEnumOptions<U>(enumObj: any): { key: string; value: U }[] {
    return Object.keys(enumObj)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        key,
        value: enumObj[key] as U
      }));
  }
}
